module.exports = __webpack_public_path__ + "img/icon-01.69570ef3.svg";